<template>
  <Plotly
    v-if="computedData.length > 0"
    :data="computedData"
    :layout="computedLayout"
    :to-image-button-options="defaultConfiguration.toImageButtonOptions"
    :displaylogo="false"
  ></Plotly>
</template>

<script>
import deepmerge from "deepmerge";
import { Plotly } from "vue-plotly";

const logo = require("@/assets/rex-logo.png");

const acelerexLogo = {
  xref: "paper",
  yref: "paper",
  x: 1,
  y: 0.05,
  sizex: 0.09,
  sizey: 0.09,
  xanchor: "right",
  yanchor: "bottom",
  opacity: 1,
  layer: "middle",
  source: `${window.location.protocol}//${window.location.host}${logo}`,
  alt: "rex-logo",
};

export default {
  name: "PlotlyChart",
  components: { Plotly },
  mixins: [],
  props: {
    data: { type: Array, required: false, default: () => [] },
    layout: { type: Object, required: false, default: () => {} },
  },
  data() {
    return {
      defaultLayout: {
        title: {
          font: {
            size: 14,
          },
        },
        images: [acelerexLogo],
      },
      defaultConfiguration: {
        toImageButtonOptions: {
          format: "png", // one of png, svg, jpeg, webp
          filename: "custom_image",
          height: 500,
          width: 1000,
          scale: 8, // Multiply title/legend/axis/canvas sizes by this factor
        },
      },
    };
  },
  computed: {
    computedLayout() {
      const mergedLayout = deepmerge(this.defaultLayout, this.layout);
      const hasLogo = mergedLayout.images.some((el) => el.alt === "rex-logo");
      if (!hasLogo) {
        // images don't have logo.
        mergedLayout.images.concat([acelerexLogo]);
      }
      return mergedLayout;
    },
    computedData() {
      return this.data;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
